export const APP_SETTING_ADD_PROJECT_CONSTANT_BEGIN = 'APP_SETTING_ADD_PROJECT_CONSTANT_BEGIN';
export const APP_SETTING_ADD_PROJECT_CONSTANT_SUCCESS = 'APP_SETTING_ADD_PROJECT_CONSTANT_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE = 'APP_SETTING_ADD_PROJECT_CONSTANT_FAILURE';
export const APP_SETTING_ADD_PROJECT_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_DEFAULT_PAGE_BEGIN = 'APP_SETTING_DEFAULT_PAGE_BEGIN';
export const APP_SETTING_DEFAULT_PAGE_SUCCESS = 'APP_SETTING_DEFAULT_PAGE_SUCCESS';
export const APP_SETTING_DEFAULT_PAGE_FAILURE = 'APP_SETTING_DEFAULT_PAGE_FAILURE';
export const APP_SETTING_DEFAULT_PAGE_DISMISS_ERROR = 'APP_SETTING_DEFAULT_PAGE_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_CONSTANT_BEGIN =
  'APP_SETTING_DELETE_PROJECT_CONSTANT_BEGIN';
export const APP_SETTING_DELETE_PROJECT_CONSTANT_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_CONSTANT_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_CONSTANT_FAILURE =
  'APP_SETTING_DELETE_PROJECT_CONSTANT_FAILURE';
export const APP_SETTING_DELETE_PROJECT_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_UPDATE_PROJECT_CONSTANT_BEGIN =
  'APP_SETTING_UPDATE_PROJECT_CONSTANT_BEGIN';
export const APP_SETTING_UPDATE_PROJECT_CONSTANT_SUCCESS =
  'APP_SETTING_UPDATE_PROJECT_CONSTANT_SUCCESS';
export const APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE =
  'APP_SETTING_UPDATE_PROJECT_CONSTANT_FAILURE';
export const APP_SETTING_UPDATE_PROJECT_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_UPDATE_PROJECT_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_BEGIN = 'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_BEGIN';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_SUCCESS =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_DISMISS_ERROR';
export const APP_SETTING_LOAD_DEFAULT_PAGE_BEGIN = 'APP_SETTING_LOAD_DEFAULT_PAGE_BEGIN';
export const APP_SETTING_LOAD_DEFAULT_PAGE_SUCCESS = 'APP_SETTING_LOAD_DEFAULT_PAGE_SUCCESS';
export const APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE = 'APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE';
export const APP_SETTING_LOAD_DEFAULT_PAGE_DISMISS_ERROR =
  'APP_SETTING_LOAD_DEFAULT_PAGE_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_ROBOTS_TXT_BEGIN = 'APP_SETTING_ADD_PROJECT_ROBOTS_TXT_BEGIN';
export const APP_SETTING_ADD_PROJECT_ROBOTS_TXT_SUCCESS =
  'APP_SETTING_ADD_PROJECT_ROBOTS_TXT_SUCCESS';
export const APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE =
  'APP_SETTING_ADD_PROJECT_ROBOTS_TXT_FAILURE';
export const APP_SETTING_ADD_PROJECT_ROBOTS_TXT_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_ROBOTS_TXT_DISMISS_ERROR';
export const APP_SETTING_LOAD_APP_SETTING_PAGES_BEGIN = 'APP_SETTING_LOAD_APP_SETTING_PAGES_BEGIN';
export const APP_SETTING_LOAD_APP_SETTING_PAGES_SUCCESS =
  'APP_SETTING_LOAD_APP_SETTING_PAGES_SUCCESS';
export const APP_SETTING_LOAD_APP_SETTING_PAGES_FAILURE =
  'APP_SETTING_LOAD_APP_SETTING_PAGES_FAILURE';
export const APP_SETTING_LOAD_APP_SETTING_PAGES_DISMISS_ERROR =
  'APP_SETTING_LOAD_APP_SETTING_PAGES_DISMISS_ERROR';
export const APP_SETTING_LOAD_PAGE_SNAPSHOTS_BEGIN = 'APP_SETTING_LOAD_PAGE_SNAPSHOTS_BEGIN';
export const APP_SETTING_LOAD_PAGE_SNAPSHOTS_SUCCESS = 'APP_SETTING_LOAD_PAGE_SNAPSHOTS_SUCCESS';
export const APP_SETTING_LOAD_PAGE_SNAPSHOTS_FAILURE = 'APP_SETTING_LOAD_PAGE_SNAPSHOTS_FAILURE';
export const APP_SETTING_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR =
  'APP_SETTING_LOAD_PAGE_SNAPSHOTS_DISMISS_ERROR';
export const APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_BEGIN = 'APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_BEGIN';
export const APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_SUCCESS =
  'APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_SUCCESS';
export const APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_FAILURE =
  'APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_FAILURE';
export const APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR =
  'APP_SETTING_LOAD_SNIPPET_SNAPSHOTS_DISMISS_ERROR';
export const APP_SETTING_CHANGE_PROJECT_LOADING_ICON_BEGIN =
  'APP_SETTING_CHANGE_PROJECT_LOADING_ICON_BEGIN';
export const APP_SETTING_CHANGE_PROJECT_LOADING_ICON_SUCCESS =
  'APP_SETTING_CHANGE_PROJECT_LOADING_ICON_SUCCESS';
export const APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE =
  'APP_SETTING_CHANGE_PROJECT_LOADING_ICON_FAILURE';
export const APP_SETTING_CHANGE_PROJECT_LOADING_ICON_DISMISS_ERROR =
  'APP_SETTING_CHANGE_PROJECT_LOADING_ICON_DISMISS_ERROR';
export const APP_SETTING_SAVE_LAYOUT_BEGIN = 'APP_SETTING_SAVE_LAYOUT_BEGIN';
export const APP_SETTING_SAVE_LAYOUT_SUCCESS = 'APP_SETTING_SAVE_LAYOUT_SUCCESS';
export const APP_SETTING_SAVE_LAYOUT_FAILURE = 'APP_SETTING_SAVE_LAYOUT_FAILURE';
export const APP_SETTING_SAVE_LAYOUT_DISMISS_ERROR = 'APP_SETTING_SAVE_LAYOUT_DISMISS_ERROR';
export const APP_SETTING_LOAD_LAYOUTS_BEGIN = 'APP_SETTING_LOAD_LAYOUTS_BEGIN';
export const APP_SETTING_LOAD_LAYOUTS_SUCCESS = 'APP_SETTING_LOAD_LAYOUTS_SUCCESS';
export const APP_SETTING_LOAD_LAYOUTS_FAILURE = 'APP_SETTING_LOAD_LAYOUTS_FAILURE';
export const APP_SETTING_LOAD_LAYOUTS_DISMISS_ERROR = 'APP_SETTING_LOAD_LAYOUTS_DISMISS_ERROR';
export const APP_SETTING_DELETE_LAYOUT_BEGIN = 'APP_SETTING_DELETE_LAYOUT_BEGIN';
export const APP_SETTING_DELETE_LAYOUT_SUCCESS = 'APP_SETTING_DELETE_LAYOUT_SUCCESS';
export const APP_SETTING_DELETE_LAYOUT_FAILURE = 'APP_SETTING_DELETE_LAYOUT_FAILURE';
export const APP_SETTING_DELETE_LAYOUT_DISMISS_ERROR = 'APP_SETTING_DELETE_LAYOUT_DISMISS_ERROR';
export const APP_SETTING_UPDATE_LAYOUT_BEGIN = 'APP_SETTING_UPDATE_LAYOUT_BEGIN';
export const APP_SETTING_UPDATE_LAYOUT_SUCCESS = 'APP_SETTING_UPDATE_LAYOUT_SUCCESS';
export const APP_SETTING_UPDATE_LAYOUT_FAILURE = 'APP_SETTING_UPDATE_LAYOUT_FAILURE';
export const APP_SETTING_UPDATE_LAYOUT_DISMISS_ERROR = 'APP_SETTING_UPDATE_LAYOUT_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_BEGIN =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_BEGIN';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_SUCCESS =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_FAILURE';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_KLASS_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_BEGIN =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_BEGIN';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_FAILURE =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_FAILURE';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_CLASS_DISMISS_ERROR';
export const APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_BEGIN =
  'APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_BEGIN';
export const APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_SUCCESS =
  'APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_SUCCESS';
export const APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE =
  'APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_FAILURE';
export const APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_DISMISS_ERROR =
  'APP_SETTING_ADD_ENVIRONMENT_IN_PROJECT_DISMISS_ERROR';
export const APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_BEGIN =
  'APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_BEGIN';
export const APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_SUCCESS =
  'APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_SUCCESS';
export const APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE =
  'APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_FAILURE';
export const APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_DISMISS_ERROR =
  'APP_SETTING_REMOVE_ENVIRONMENT_FROM_PROJECT_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_BEGIN =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_BEGIN';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_SUCCESS =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_FAILURE =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_FAILURE';
export const APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CUSTOM_CSS_URL_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_BEGIN =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_BEGIN';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_FAILURE =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_FAILURE';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_CSS_URL_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_BEGIN = 'APP_SETTING_ADD_PROJECT_CUSTOM_JS_BEGIN';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_SUCCESS =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_FAILURE';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_BEGIN =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_BEGIN';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_SUCCESS =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_SUCCESS';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_FAILURE';
export const APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_BEGIN =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_BEGIN';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_FAILURE =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_FAILURE';
export const APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_BEGIN =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_BEGIN';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_SUCCESS =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_SUCCESS';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_FAILURE =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_FAILURE';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_BEGIN =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_BEGIN';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_SUCCESS =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_SUCCESS';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_FAILURE =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_FAILURE';
export const APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_DISMISS_ERROR =
  'APP_SETTING_UPDATE_PROJECT_CUSTOM_CSS_CDN_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_BEGIN =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_BEGIN';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_SUCCESS =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_SUCCESS';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_FAILURE =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_FAILURE';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_JS_DISMISS_ERROR';
export const APP_SETTING_SAVE_PROJECT_PWA_CONFIG_BEGIN =
  'APP_SETTING_SAVE_PROJECT_PWA_CONFIG_BEGIN';
export const APP_SETTING_SAVE_PROJECT_PWA_CONFIG_SUCCESS =
  'APP_SETTING_SAVE_PROJECT_PWA_CONFIG_SUCCESS';
export const APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE =
  'APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE';
export const APP_SETTING_SAVE_PROJECT_PWA_CONFIG_DISMISS_ERROR =
  'APP_SETTING_SAVE_PROJECT_PWA_CONFIG_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_PWA_CONFIG_BEGIN =
  'APP_SETTING_DELETE_PROJECT_PWA_CONFIG_BEGIN';
export const APP_SETTING_DELETE_PROJECT_PWA_CONFIG_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_PWA_CONFIG_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE =
  'APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE';
export const APP_SETTING_DELETE_PROJECT_PWA_CONFIG_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_PWA_CONFIG_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PWA_BEGIN = 'APP_SETTING_TOGGLE_PWA_BEGIN';
export const APP_SETTING_TOGGLE_PWA_SUCCESS = 'APP_SETTING_TOGGLE_PWA_SUCCESS';
export const APP_SETTING_TOGGLE_PWA_FAILURE = 'APP_SETTING_TOGGLE_PWA_FAILURE';
export const APP_SETTING_TOGGLE_PWA_DISMISS_ERROR = 'APP_SETTING_TOGGLE_PWA_DISMISS_ERROR';
export const APP_SETTING_UPDATE_DEV_KEY_BEGIN = 'APP_SETTING_UPDATE_DEV_KEY_BEGIN';
export const APP_SETTING_UPDATE_DEV_KEY_SUCCESS = 'APP_SETTING_UPDATE_DEV_KEY_SUCCESS';
export const APP_SETTING_UPDATE_DEV_KEY_FAILURE = 'APP_SETTING_UPDATE_DEV_KEY_FAILURE';
export const APP_SETTING_UPDATE_DEV_KEY_DISMISS_ERROR = 'APP_SETTING_UPDATE_DEV_KEY_DISMISS_ERROR';
export const APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_BEGIN =
  'APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_BEGIN';
export const APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_SUCCESS =
  'APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_SUCCESS';
export const APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE =
  'APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_FAILURE';
export const APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_DISMISS_ERROR =
  'APP_SETTING_UPDATE_ENVIRONMENT_PROJECT_DISMISS_ERROR';
export const APP_SETTING_ADD_ENV_CONSTANT_BEGIN = 'APP_SETTING_ADD_ENV_CONSTANT_BEGIN';
export const APP_SETTING_ADD_ENV_CONSTANT_SUCCESS = 'APP_SETTING_ADD_ENV_CONSTANT_SUCCESS';
export const APP_SETTING_ADD_ENV_CONSTANT_FAILURE = 'APP_SETTING_ADD_ENV_CONSTANT_FAILURE';
export const APP_SETTING_ADD_ENV_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_ADD_ENV_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_UPDATE_ENV_CONSTANT_BEGIN = 'APP_SETTING_UPDATE_ENV_CONSTANT_BEGIN';
export const APP_SETTING_UPDATE_ENV_CONSTANT_SUCCESS = 'APP_SETTING_UPDATE_ENV_CONSTANT_SUCCESS';
export const APP_SETTING_UPDATE_ENV_CONSTANT_FAILURE = 'APP_SETTING_UPDATE_ENV_CONSTANT_FAILURE';
export const APP_SETTING_UPDATE_ENV_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_UPDATE_ENV_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_REMOVE_ENV_CONSTANT_BEGIN = 'APP_SETTING_REMOVE_ENV_CONSTANT_BEGIN';
export const APP_SETTING_REMOVE_ENV_CONSTANT_SUCCESS = 'APP_SETTING_REMOVE_ENV_CONSTANT_SUCCESS';
export const APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE = 'APP_SETTING_REMOVE_ENV_CONSTANT_FAILURE';
export const APP_SETTING_REMOVE_ENV_CONSTANT_DISMISS_ERROR =
  'APP_SETTING_REMOVE_ENV_CONSTANT_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_ALL_DEV_KEY_BEGIN = 'APP_SETTING_TOGGLE_ALL_DEV_KEY_BEGIN';
export const APP_SETTING_TOGGLE_ALL_DEV_KEY_SUCCESS = 'APP_SETTING_TOGGLE_ALL_DEV_KEY_SUCCESS';
export const APP_SETTING_TOGGLE_ALL_DEV_KEY_FAILURE = 'APP_SETTING_TOGGLE_ALL_DEV_KEY_FAILURE';
export const APP_SETTING_TOGGLE_ALL_DEV_KEY_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_ALL_DEV_KEY_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_THEME_FILES_BEGIN =
  'APP_SETTING_LOAD_CUSTOM_THEME_FILES_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_THEME_FILES_SUCCESS =
  'APP_SETTING_LOAD_CUSTOM_THEME_FILES_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_THEME_FILES_FAILURE =
  'APP_SETTING_LOAD_CUSTOM_THEME_FILES_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_THEME_FILES_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_THEME_FILES_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_THEME_FILE_BEGIN =
  'APP_SETTING_DELETE_CUSTOM_THEME_FILE_BEGIN';
export const APP_SETTING_DELETE_CUSTOM_THEME_FILE_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_THEME_FILE_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_THEME_FILE_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_THEME_FILE_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_THEME_FILE_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_THEME_FILE_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_CSS_CDNS_BEGIN = 'APP_SETTING_LOAD_CUSTOM_CSS_CDNS_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_CSS_CDNS_SUCCESS = 'APP_SETTING_LOAD_CUSTOM_CSS_CDNS_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_CSS_CDNS_FAILURE = 'APP_SETTING_LOAD_CUSTOM_CSS_CDNS_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_CSS_CDNS_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_CSS_CDNS_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_CSS_FILE_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_CSS_FILE_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_CSS_FILE_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_CSS_FILE_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_CSS_FILE_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_CSS_FILE_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_JS_CDNS_BEGIN = 'APP_SETTING_LOAD_CUSTOM_JS_CDNS_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_JS_CDNS_SUCCESS = 'APP_SETTING_LOAD_CUSTOM_JS_CDNS_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_JS_CDNS_FAILURE = 'APP_SETTING_LOAD_CUSTOM_JS_CDNS_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_JS_CDNS_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_JS_CDNS_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_JS_FILE_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_JS_FILE_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_JS_FILE_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_JS_FILE_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_JS_FILE_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_JS_FILE_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_ENCRYPTION_BEGIN = 'APP_SETTING_TOGGLE_ENCRYPTION_BEGIN';
export const APP_SETTING_TOGGLE_ENCRYPTION_SUCCESS = 'APP_SETTING_TOGGLE_ENCRYPTION_SUCCESS';
export const APP_SETTING_TOGGLE_ENCRYPTION_FAILURE = 'APP_SETTING_TOGGLE_ENCRYPTION_FAILURE';
export const APP_SETTING_TOGGLE_ENCRYPTION_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_ENCRYPTION_DISMISS_ERROR';
export const APP_SETTING_UPDATE_ENCRYPTION_SETTING_BEGIN =
  'APP_SETTING_UPDATE_ENCRYPTION_SETTING_BEGIN';
export const APP_SETTING_UPDATE_ENCRYPTION_SETTING_SUCCESS =
  'APP_SETTING_UPDATE_ENCRYPTION_SETTING_SUCCESS';
export const APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE =
  'APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE';
export const APP_SETTING_UPDATE_ENCRYPTION_SETTING_DISMISS_ERROR =
  'APP_SETTING_UPDATE_ENCRYPTION_SETTING_DISMISS_ERROR';
export const APP_SETTING_ADD_NOTIFICATION_SETTING_BEGIN =
  'APP_SETTING_ADD_NOTIFICATION_SETTING_BEGIN';
export const APP_SETTING_ADD_NOTIFICATION_SETTING_SUCCESS =
  'APP_SETTING_ADD_NOTIFICATION_SETTING_SUCCESS';
export const APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE =
  'APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE';
export const APP_SETTING_ADD_NOTIFICATION_SETTING_DISMISS_ERROR =
  'APP_SETTING_ADD_NOTIFICATION_SETTING_DISMISS_ERROR';
export const APP_SETTING_DELETE_PAGE_SNAPSHOT_BEGIN = 'APP_SETTING_DELETE_PAGE_SNAPSHOT_BEGIN';
export const APP_SETTING_DELETE_PAGE_SNAPSHOT_SUCCESS = 'APP_SETTING_DELETE_PAGE_SNAPSHOT_SUCCESS';
export const APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE = 'APP_SETTING_DELETE_PAGE_SNAPSHOT_FAILURE';
export const APP_SETTING_DELETE_PAGE_SNAPSHOT_DISMISS_ERROR =
  'APP_SETTING_DELETE_PAGE_SNAPSHOT_DISMISS_ERROR';
export const APP_SETTING_DELETE_SNIPPET_SNAPSHOT_BEGIN =
  'APP_SETTING_DELETE_SNIPPET_SNAPSHOT_BEGIN';
export const APP_SETTING_DELETE_SNIPPET_SNAPSHOT_SUCCESS =
  'APP_SETTING_DELETE_SNIPPET_SNAPSHOT_SUCCESS';
export const APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE =
  'APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE';
export const APP_SETTING_DELETE_SNIPPET_SNAPSHOT_DISMISS_ERROR =
  'APP_SETTING_DELETE_SNIPPET_SNAPSHOT_DISMISS_ERROR';
export const APP_SETTING_LOAD_LOCALIZATION_DATA_BEGIN = 'APP_SETTING_LOAD_LOCALIZATION_DATA_BEGIN';
export const APP_SETTING_LOAD_LOCALIZATION_DATA_SUCCESS =
  'APP_SETTING_LOAD_LOCALIZATION_DATA_SUCCESS';
export const APP_SETTING_LOAD_LOCALIZATION_DATA_FAILURE =
  'APP_SETTING_LOAD_LOCALIZATION_DATA_FAILURE';
export const APP_SETTING_LOAD_LOCALIZATION_DATA_DISMISS_ERROR =
  'APP_SETTING_LOAD_LOCALIZATION_DATA_DISMISS_ERROR';
export const APP_SETTING_SAVE_LOCALIZATION_CONFIG_BEGIN =
  'APP_SETTING_SAVE_LOCALIZATION_CONFIG_BEGIN';
export const APP_SETTING_SAVE_LOCALIZATION_CONFIG_SUCCESS =
  'APP_SETTING_SAVE_LOCALIZATION_CONFIG_SUCCESS';
export const APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE =
  'APP_SETTING_SAVE_LOCALIZATION_CONFIG_FAILURE';
export const APP_SETTING_SAVE_LOCALIZATION_CONFIG_DISMISS_ERROR =
  'APP_SETTING_SAVE_LOCALIZATION_CONFIG_DISMISS_ERROR';
export const APP_SETTING_DELETE_LOCALIZATION_CONFIG_BEGIN =
  'APP_SETTING_DELETE_LOCALIZATION_CONFIG_BEGIN';
export const APP_SETTING_DELETE_LOCALIZATION_CONFIG_SUCCESS =
  'APP_SETTING_DELETE_LOCALIZATION_CONFIG_SUCCESS';
export const APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE =
  'APP_SETTING_DELETE_LOCALIZATION_CONFIG_FAILURE';
export const APP_SETTING_DELETE_LOCALIZATION_CONFIG_DISMISS_ERROR =
  'APP_SETTING_DELETE_LOCALIZATION_CONFIG_DISMISS_ERROR';
export const APP_SETTING_ADD_ACTIVE_LANGUAGE_DISMISS_ERROR =
  'APP_SETTING_ADD_ACTIVE_LANGUAGE_DISMISS_ERROR';
export const APP_SETTING_DELETE_ACTIVE_LANGUAGE_SUCCESS =
  'APP_SETTING_DELETE_ACTIVE_LANGUAGE_SUCCESS';
export const APP_SETTING_DELETE_ACTIVE_LANGUAGE_FAILURE =
  'APP_SETTING_DELETE_ACTIVE_LANGUAGE_FAILURE';
export const APP_SETTING_DELETE_ACTIVE_LANGUAGE_DISMISS_ERROR =
  'APP_SETTING_DELETE_ACTIVE_LANGUAGE_DISMISS_ERROR';
export const APP_SETTING_UPDATE_LOCALIZATION_CONFIG_BEGIN =
  'APP_SETTING_UPDATE_LOCALIZATION_CONFIG_BEGIN';
export const APP_SETTING_UPDATE_LOCALIZATION_CONFIG_SUCCESS =
  'APP_SETTING_UPDATE_LOCALIZATION_CONFIG_SUCCESS';
export const APP_SETTING_UPDATE_LOCALIZATION_CONFIG_FAILURE =
  'APP_SETTING_UPDATE_LOCALIZATION_CONFIG_FAILURE';
export const APP_SETTING_UPDATE_LOCALIZATION_CONFIG_DISMISS_ERROR =
  'APP_SETTING_UPDATE_LOCALIZATION_CONFIG_DISMISS_ERROR';
export const APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_BEGIN =
  'APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_BEGIN';
export const APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_SUCCESS =
  'APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_SUCCESS';
export const APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE =
  'APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_FAILURE';
export const APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_DISMISS_ERROR =
  'APP_SETTING_ADD_LOCALIZATION_KEY_VALUE_DISMISS_ERROR';
export const APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_BEGIN =
  'APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_BEGIN';
export const APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_SUCCESS =
  'APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_SUCCESS';
export const APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE =
  'APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE';
export const APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR =
  'APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR';
export const APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_BEGIN =
  'APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_BEGIN';
export const APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_SUCCESS =
  'APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_SUCCESS';
export const APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE =
  'APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_FAILURE';
export const APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR =
  'APP_SETTING_UPDATE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR';
export const APP_SETTING_CHANGE_DEFAULT_LANGUAGE_BEGIN =
  'APP_SETTING_CHANGE_DEFAULT_LANGUAGE_BEGIN';
export const APP_SETTING_CHANGE_DEFAULT_LANGUAGE_SUCCESS =
  'APP_SETTING_CHANGE_DEFAULT_LANGUAGE_SUCCESS';
export const APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE =
  'APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE';
export const APP_SETTING_CHANGE_DEFAULT_LANGUAGE_DISMISS_ERROR =
  'APP_SETTING_CHANGE_DEFAULT_LANGUAGE_DISMISS_ERROR';
export const APP_SETTING_UPDATE_DATE_FORMAT_BEGIN = 'APP_SETTING_UPDATE_DATE_FORMAT_BEGIN';
export const APP_SETTING_UPDATE_DATE_FORMAT_SUCCESS = 'APP_SETTING_UPDATE_DATE_FORMAT_SUCCESS';
export const APP_SETTING_UPDATE_DATE_FORMAT_FAILURE = 'APP_SETTING_UPDATE_DATE_FORMAT_FAILURE';
export const APP_SETTING_UPDATE_DATE_FORMAT_DISMISS_ERROR =
  'APP_SETTING_UPDATE_DATE_FORMAT_DISMISS_ERROR';
export const APP_SETTING_FETCH_CSSDATA_BEGIN = 'APP_SETTING_FETCH_CSSDATA_BEGIN';
export const APP_SETTING_FETCH_CSSDATA_SUCCESS = 'APP_SETTING_FETCH_CSSDATA_SUCCESS';
export const APP_SETTING_FETCH_CSSDATA_FAILURE = 'APP_SETTING_FETCH_CSSDATA_FAILURE';
export const APP_SETTING_FETCH_CSSDATA_DISMISS_ERROR = 'APP_SETTING_FETCH_CSSDATA_DISMISS_ERROR';
export const APP_SETTING_FETCH_JS_EDITOR_DATA_BEGIN = 'APP_SETTING_FETCH_JS_EDITOR_DATA_BEGIN';
export const APP_SETTING_FETCH_JS_EDITOR_DATA_SUCCESS = 'APP_SETTING_FETCH_JS_EDITOR_DATA_SUCCESS';
export const APP_SETTING_FETCH_JS_EDITOR_DATA_FAILURE = 'APP_SETTING_FETCH_JS_EDITOR_DATA_FAILURE';
export const APP_SETTING_FETCH_JS_EDITOR_DATA_DISMISS_ERROR =
  'APP_SETTING_FETCH_JS_EDITOR_DATA_DISMISS_ERROR';

export const APP_SETTING_TOGGLE_CSS_EDITOR_MODAL = 'APP_SETTING_TOGGLE_CSS_EDITOR_MODAL';
export const APP_SETTING_SAVE_CSS_FILE_BEGIN = 'APP_SETTING_SAVE_CSS_FILE_BEGIN';
export const APP_SETTING_SAVE_CSS_FILE_SUCCESS = 'APP_SETTING_SAVE_CSS_FILE_SUCCESS';
export const APP_SETTING_SAVE_CSS_FILE_FAILURE = 'APP_SETTING_SAVE_CSS_FILE_FAILURE';
export const APP_SETTING_SAVE_CSS_FILE_DISMISS_ERROR = 'APP_SETTING_SAVE_CSS_FILE_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_JS_EDITOR_MODAL = 'APP_SETTING_TOGGLE_JS_EDITOR_MODAL';
export const APP_SETTING_SAVE_JS_FILE_BEGIN = 'APP_SETTING_SAVE_JS_FILE_BEGIN';
export const APP_SETTING_SAVE_JS_FILE_SUCCESS = 'APP_SETTING_SAVE_JS_FILE_SUCCESS';
export const APP_SETTING_SAVE_JS_FILE_FAILURE = 'APP_SETTING_SAVE_JS_FILE_FAILURE';
export const APP_SETTING_SAVE_JS_FILE_DISMISS_ERROR = 'APP_SETTING_SAVE_JS_FILE_DISMISS_ERROR';

export const APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_BEGIN =
  'APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_BEGIN';
export const APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_SUCCESS =
  'APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_SUCCESS';
export const APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE =
  'APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE';
export const APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_DISMISS_ERROR';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN =
  'APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS =
  'APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE =
  'APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_BEGIN =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_BEGIN';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_SUCCESS =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_SUCCESS';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_FAILURE =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_FAILURE';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CONFIG_DISMISS_ERROR';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'APP_SETTING_ADD_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_BEGIN =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_BEGIN';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_SUCCESS =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_SUCCESS';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_FAILURE =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_FAILURE';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_JS_CDN_DISMISS_ERROR';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_BEGIN';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_SUCCESS';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_FAILURE';
export const APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR =
  'APP_SETTING_UPDATE_CUSTOM_COMPONENT_CSS_CDN_DISMISS_ERROR';
export const APP_SETTING_ADD_CUSTOM_DATA_MAPPING_BEGIN =
  'APP_SETTING_ADD_CUSTOM_DATA_MAPPING_BEGIN';
export const APP_SETTING_ADD_CUSTOM_DATA_MAPPING_SUCCESS =
  'APP_SETTING_ADD_CUSTOM_DATA_MAPPING_SUCCESS';
export const APP_SETTING_ADD_CUSTOM_DATA_MAPPING_FAILURE =
  'APP_SETTING_ADD_CUSTOM_DATA_MAPPING_FAILURE';
export const APP_SETTING_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'APP_SETTING_ADD_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_BEGIN =
  'APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_SUCCESS =
  'APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_FAILURE =
  'APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_BEGIN =
  'APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_BEGIN';
export const APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_SUCCESS =
  'APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_SUCCESS';
export const APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_FAILURE =
  'APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_FAILURE';
export const APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_DISMISS_ERROR =
  'APP_SETTING_UPDATE_CUSTOM_DATA_MAPPING_DISMISS_ERROR';
export const APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_BEGIN =
  'APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_BEGIN';
export const APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_SUCCESS =
  'APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_SUCCESS';
export const APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_FAILURE =
  'APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_FAILURE';
export const APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_DISMISS_ERROR =
  'APP_SETTING_DELETE_CUSTOM_DATA_MAPPINNG_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_BEGIN =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_BEGIN';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_SUCCESS =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_SUCCESS';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_FAILURE =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_FAILURE';
export const APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_BEGIN =
  'APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_BEGIN';
export const APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_SUCCESS =
  'APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_SUCCESS';
export const APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE =
  'APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE';
export const APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_BEGIN =
  'APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_BEGIN';
export const APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_SUCCESS =
  'APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_SUCCESS';
export const APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_FAILURE =
  'APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_FAILURE';
export const APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROJECT_CSS_CDNS_FROM_BUILDER_DISMISS_ERROR';
export const APP_SETTING_TOGGLE_PROFILER_BEGIN = 'APP_SETTING_TOGGLE_PROFILER_BEGIN';
export const APP_SETTING_TOGGLE_PROFILER_SUCCESS = 'APP_SETTING_TOGGLE_PROFILER_SUCCESS';
export const APP_SETTING_TOGGLE_PROFILER_FAILURE = 'APP_SETTING_TOGGLE_PROFILER_FAILURE';
export const APP_SETTING_TOGGLE_PROFILER_DISMISS_ERROR =
  'APP_SETTING_TOGGLE_PROFILER_DISMISS_ERROR';

export const APP_SETTING_GET_ALL_TRACKING_ACTIVITY_BEGIN =
  'APP_SETTING_GET_ALL_TRACKING_ACTIVITY_BEGIN';
export const APP_SETTING_GET_ALL_TRACKING_ACTIVITY_SUCCESS =
  'APP_SETTING_GET_ALL_TRACKING_ACTIVITY_SUCCESS';
export const APP_SETTING_GET_ALL_TRACKING_ACTIVITY_FAILURE =
  'APP_SETTING_GET_ALL_TRACKING_ACTIVITY_FAILURE';
export const APP_SETTING_GET_ALL_TRACKING_ACTIVITY_DISMISS_ERROR =
  'APP_SETTING_GET_ALL_TRACKING_ACTIVITY_DISMISS_ERROR';
export const APP_SETTING_CREATE_PROJECT_VERSION_BEGIN = 'APP_SETTING_CREATE_PROJECT_VERSION_BEGIN';
export const APP_SETTING_CREATE_PROJECT_VERSION_SUCCESS =
  'APP_SETTING_CREATE_PROJECT_VERSION_SUCCESS';
export const APP_SETTING_CREATE_PROJECT_VERSION_FAILURE =
  'APP_SETTING_CREATE_PROJECT_VERSION_FAILURE';
export const APP_SETTING_CREATE_PROJECT_VERSION_DISMISS_ERROR =
  'APP_SETTING_CREATE_PROJECT_VERSION_DISMISS_ERROR';
export const APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_BEGIN =
  'APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_BEGIN';
export const APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_SUCCESS =
  'APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_SUCCESS';
export const APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_FAILURE =
  'APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_FAILURE';
export const APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_DISMISS_ERROR =
  'APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROJECT_VERSION_BEGIN = 'APP_SETTING_DELETE_PROJECT_VERSION_BEGIN';
export const APP_SETTING_DELETE_PROJECT_VERSION_SUCCESS =
  'APP_SETTING_DELETE_PROJECT_VERSION_SUCCESS';
export const APP_SETTING_DELETE_PROJECT_VERSION_FAILURE =
  'APP_SETTING_DELETE_PROJECT_VERSION_FAILURE';
export const APP_SETTING_DELETE_PROJECT_VERSION_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROJECT_VERSION_DISMISS_ERROR';
export const APP_SETTING_GET_PUBLISHTRACK_BEGIN = 'APP_SETTING_GET_PUBLISHTRACK_BEGIN';
export const APP_SETTING_GET_PUBLISHTRACK_SUCCESS = 'APP_SETTING_GET_PUBLISHTRACK_SUCCESS';
export const APP_SETTING_GET_PUBLISHTRACK_FAILURE = 'APP_SETTING_GET_PUBLISHTRACK_FAILURE';
export const APP_SETTING_GET_PUBLISHTRACK_DISMISS_ERROR =
  'APP_SETTING_GET_PUBLISHTRACK_DISMISS_ERROR';
export const APP_SETTING_LOAD_CUSTOM_HTML_FILES_BEGIN = 'APP_SETTING_LOAD_CUSTOM_HTML_FILES_BEGIN';
export const APP_SETTING_LOAD_CUSTOM_HTML_FILES_SUCCESS =
  'APP_SETTING_LOAD_CUSTOM_HTML_FILES_SUCCESS';
export const APP_SETTING_LOAD_CUSTOM_HTML_FILES_FAILURE =
  'APP_SETTING_LOAD_CUSTOM_HTML_FILES_FAILURE';
export const APP_SETTING_LOAD_CUSTOM_HTML_FILES_DISMISS_ERROR =
  'APP_SETTING_LOAD_CUSTOM_HTML_FILES_DISMISS_ERROR';
export const APP_SETTING_LOAD_ALL_RESOURCES_BEGIN = 'APP_SETTING_LOAD_ALL_RESOURCES_BEGIN';
export const APP_SETTING_LOAD_ALL_RESOURCES_SUCCESS = 'APP_SETTING_LOAD_ALL_RESOURCES_SUCCESS';
export const APP_SETTING_LOAD_ALL_RESOURCES_FAILURE = 'APP_SETTING_LOAD_ALL_RESOURCES_FAILURE';
export const APP_SETTING_LOAD_ALL_RESOURCES_DISMISS_ERROR =
  'APP_SETTING_LOAD_ALL_RESOURCES_DISMISS_ERROR';
export const APP_SETTING_DELETE_RESOURCES_BEGIN = 'APP_SETTING_DELETE_RESOURCES_BEGIN';
export const APP_SETTING_DELETE_RESOURCES_SUCCESS = 'APP_SETTING_DELETE_RESOURCES_SUCCESS';
export const APP_SETTING_DELETE_RESOURCES_FAILURE = 'APP_SETTING_DELETE_RESOURCES_FAILURE';
export const APP_SETTING_DELETE_RESOURCES_DISMISS_ERROR =
  'APP_SETTING_DELETE_RESOURCES_DISMISS_ERROR';
export const APP_SETTING_LOAD_PAGE_DETAILS_BEGIN = 'APP_SETTING_LOAD_PAGE_DETAILS_BEGIN';
export const APP_SETTING_LOAD_PAGE_DETAILS_SUCCESS = 'APP_SETTING_LOAD_PAGE_DETAILS_SUCCESS';
export const APP_SETTING_LOAD_PAGE_DETAILS_FAILURE = 'APP_SETTING_LOAD_PAGE_DETAILS_FAILURE';
export const APP_SETTING_LOAD_PAGE_DETAILS_DISMISS_ERROR =
  'APP_SETTING_LOAD_PAGE_DETAILS_DISMISS_ERROR';
export const APP_SETTING_UPDATE_PAGE_SCRIPT_BEGIN = 'APP_SETTING_UPDATE_PAGE_SCRIPT_BEGIN';
export const APP_SETTING_UPDATE_PAGE_SCRIPT_SUCCESS = 'APP_SETTING_UPDATE_PAGE_SCRIPT_SUCCESS';
export const APP_SETTING_UPDATE_PAGE_SCRIPT_FAILURE = 'APP_SETTING_UPDATE_PAGE_SCRIPT_FAILURE';
export const APP_SETTING_UPDATE_PAGE_SCRIPT_DISMISS_ERROR =
  'APP_SETTING_UPDATE_PAGE_SCRIPT_DISMISS_ERROR';
export const APP_SETTING_LOAD_PROJECT_COLLECTIONS_BEGIN =
  'APP_SETTING_LOAD_PROJECT_COLLECTIONS_BEGIN';
export const APP_SETTING_LOAD_PROJECT_COLLECTIONS_SUCCESS =
  'APP_SETTING_LOAD_PROJECT_COLLECTIONS_SUCCESS';
export const APP_SETTING_LOAD_PROJECT_COLLECTIONS_FAILURE =
  'APP_SETTING_LOAD_PROJECT_COLLECTIONS_FAILURE';
export const APP_SETTING_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR =
  'APP_SETTING_LOAD_PROJECT_COLLECTIONS_DISMISS_ERROR';
export const APP_SETTING_ENABLE_DEVELOPER_APIS_BEGIN = 'APP_SETTING_ENABLE_DEVELOPER_APIS_BEGIN';
export const APP_SETTING_ENABLE_DEVELOPER_APIS_SUCCESS =
  'APP_SETTING_ENABLE_DEVELOPER_APIS_SUCCESS';
export const APP_SETTING_ENABLE_DEVELOPER_APIS_FAILURE =
  'APP_SETTING_ENABLE_DEVELOPER_APIS_FAILURE';
export const APP_SETTING_ENABLE_DEVELOPER_APIS_DISMISS_ERROR =
  'APP_SETTING_ENABLE_DEVELOPER_APIS_DISMISS_ERROR';
export const APP_SETTING_LOAD_ALL_DEV_APIS_BEGIN = 'APP_SETTING_LOAD_ALL_DEV_APIS_BEGIN';
export const APP_SETTING_LOAD_ALL_DEV_APIS_SUCCESS = 'APP_SETTING_LOAD_ALL_DEV_APIS_SUCCESS';
export const APP_SETTING_LOAD_ALL_DEV_APIS_FAILURE = 'APP_SETTING_LOAD_ALL_DEV_APIS_FAILURE';
export const APP_SETTING_LOAD_ALL_DEV_APIS_DISMISS_ERROR =
  'APP_SETTING_LOAD_ALL_DEV_APIS_DISMISS_ERROR';
export const APP_SETTING_LOAD_EMAIL_TEMPLATES_BEGIN = 'APP_SETTING_LOAD_EMAIL_TEMPLATES_BEGIN';
export const APP_SETTING_LOAD_EMAIL_TEMPLATES_SUCCESS = 'APP_SETTING_LOAD_EMAIL_TEMPLATES_SUCCESS';
export const APP_SETTING_LOAD_EMAIL_TEMPLATES_FAILURE = 'APP_SETTING_LOAD_EMAIL_TEMPLATES_FAILURE';
export const APP_SETTING_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR =
  'APP_SETTING_LOAD_EMAIL_TEMPLATES_DISMISS_ERROR';
export const APP_SETTING_GET_PERMISSION_FLAGS_BEGIN = 'APP_SETTING_GET_PERMISSION_FLAGS_BEGIN';
export const APP_SETTING_GET_PERMISSION_FLAGS_SUCCESS = 'APP_SETTING_GET_PERMISSION_FLAGS_SUCCESS';
export const APP_SETTING_GET_PERMISSION_FLAGS_FAILURE = 'APP_SETTING_GET_PERMISSION_FLAGS_FAILURE';
export const APP_SETTING_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'APP_SETTING_GET_PERMISSION_FLAGS_DISMISS_ERROR';
export const APP_SETTING_CUSTOM_DOMAINS_UPDATE_BEGIN = 'APP_SETTING_CUSTOM_DOMAINS_UPDATE_BEGIN';
export const APP_SETTING_CUSTOM_DOMAINS_UPDATE_SUCCESS =
  'APP_SETTING_CUSTOM_DOMAINS_UPDATE_SUCCESS';
export const APP_SETTING_CUSTOM_DOMAINS_UPDATE_FAILURE =
  'APP_SETTING_CUSTOM_DOMAINS_UPDATE_FAILURE';
export const APP_SETTING_CUSTOM_DOMAINS_UPDATE_DISMISS_ERROR =
  'APP_SETTING_CUSTOM_DOMAINS_UPDATE_DISMISS_ERROR';
export const APP_SETTING_FETCH_PROJECT_BEGIN = 'APP_SETTING_FETCH_PROJECT_BEGIN';
export const APP_SETTING_FETCH_PROJECT_SUCCESS = 'APP_SETTING_FETCH_PROJECT_SUCCESS';
export const APP_SETTING_FETCH_PROJECT_FAILURE = 'APP_SETTING_FETCH_PROJECT_FAILURE';
export const APP_SETTING_FETCH_PROJECT_DISMISS_ERROR = 'APP_SETTING_FETCH_PROJECT_DISMISS_ERROR';
export const APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_BEGIN =
  'APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_BEGIN';
export const APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_SUCCESS =
  'APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_SUCCESS';
export const APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_FAILURE =
  'APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_FAILURE';
export const APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR =
  'APP_SETTING_LOAD_COLLECTION_SNAPSHOTS_DISMISS_ERROR';
export const APP_SETTING_DELETE_COLLECTION_SNAPSHOT_BEGIN =
  'APP_SETTING_DELETE_COLLECTION_SNAPSHOT_BEGIN';
export const APP_SETTING_DELETE_COLLECTION_SNAPSHOT_SUCCESS =
  'APP_SETTING_DELETE_COLLECTION_SNAPSHOT_SUCCESS';
export const APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE =
  'APP_SETTING_DELETE_COLLECTION_SNAPSHOT_FAILURE';
export const APP_SETTING_DELETE_COLLECTION_SNAPSHOT_DISMISS_ERROR =
  'APP_SETTING_DELETE_COLLECTION_SNAPSHOT_DISMISS_ERROR';
export const APP_SETTING_UPDATE_IP_ADDRESSES_BEGIN = 'APP_SETTING_UPDATE_IP_ADDRESSES_BEGIN';
export const APP_SETTING_UPDATE_IP_ADDRESSES_SUCCESS = 'APP_SETTING_UPDATE_IP_ADDRESSES_SUCCESS';
export const APP_SETTING_UPDATE_IP_ADDRESSES_FAILURE = 'APP_SETTING_UPDATE_IP_ADDRESSES_FAILURE';
export const APP_SETTING_UPDATE_IP_ADDRESSES_DISMISS_ERROR =
  'APP_SETTING_UPDATE_IP_ADDRESSES_DISMISS_ERROR';
export const APP_SETTING_GET_IP_ADDRESSES_BEGIN = 'APP_SETTING_GET_IP_ADDRESSES_BEGIN';
export const APP_SETTING_GET_IP_ADDRESSES_SUCCESS = 'APP_SETTING_GET_IP_ADDRESSES_SUCCESS';
export const APP_SETTING_GET_IP_ADDRESSES_FAILURE = 'APP_SETTING_GET_IP_ADDRESSES_FAILURE';
export const APP_SETTING_GET_IP_ADDRESSES_DISMISS_ERROR =
  'APP_SETTING_GET_IP_ADDRESSES_DISMISS_ERROR';
export const APP_SETTING_LOAD_USER_ROLES_BEGIN = 'APP_SETTING_LOAD_USER_ROLES_BEGIN';
export const APP_SETTING_LOAD_USER_ROLES_SUCCESS = 'APP_SETTING_LOAD_USER_ROLES_SUCCESS';
export const APP_SETTING_LOAD_USER_ROLES_FAILURE = 'APP_SETTING_LOAD_USER_ROLES_FAILURE';
export const APP_SETTING_LOAD_USER_ROLES_DISMISS_ERROR =
  'APP_SETTING_LOAD_USER_ROLES_DISMISS_ERROR';
export const APP_SETTING_LOAD_COLLECTION_ITEMS_BEGIN = 'APP_SETTING_LOAD_COLLECTION_ITEMS_BEGIN';
export const APP_SETTING_LOAD_COLLECTION_ITEMS_SUCCESS =
  'APP_SETTING_LOAD_COLLECTION_ITEMS_SUCCESS';
export const APP_SETTING_LOAD_COLLECTION_ITEMS_FAILURE =
  'APP_SETTING_LOAD_COLLECTION_ITEMS_FAILURE';
export const APP_SETTING_LOAD_COLLECTION_ITEMS_DISMISS_ERROR =
  'APP_SETTING_LOAD_COLLECTION_ITEMS_DISMISS_ERROR';
export const APP_SETTING_LOAD_PERMISSIONS_BEGIN = 'APP_SETTING_LOAD_PERMISSIONS_BEGIN';
export const APP_SETTING_LOAD_PERMISSIONS_SUCCESS = 'APP_SETTING_LOAD_PERMISSIONS_SUCCESS';
export const APP_SETTING_LOAD_PERMISSIONS_FAILURE = 'APP_SETTING_LOAD_PERMISSIONS_FAILURE';
export const APP_SETTING_LOAD_PERMISSIONS_DISMISS_ERROR =
  'APP_SETTING_LOAD_PERMISSIONS_DISMISS_ERROR';
export const APP_SETTING_ADD_PROJECT_SITEMAP_XML_BEGIN =
  'APP_SETTING_ADD_PROJECT_SITEMAP_XML_BEGIN';
export const APP_SETTING_ADD_PROJECT_SITEMAP_XML_SUCCESS =
  'APP_SETTING_ADD_PROJECT_SITEMAP_XML_SUCCESS';
export const APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE =
  'APP_SETTING_ADD_PROJECT_SITEMAP_XML_FAILURE';
export const APP_SETTING_ADD_PROJECT_SITEMAP_XML_DISMISS_ERROR =
  'APP_SETTING_ADD_PROJECT_SITEMAP_XML_DISMISS_ERROR';
export const APP_SETTING_OVERWRITE_DEFAULT_UI_BEGIN = 'APP_SETTING_OVERWRITE_DEFAULT_UI_BEGIN';
export const APP_SETTING_OVERWRITE_DEFAULT_UI_SUCCESS = 'APP_SETTING_OVERWRITE_DEFAULT_UI_SUCCESS';
export const APP_SETTING_OVERWRITE_DEFAULT_UI_FAILURE = 'APP_SETTING_OVERWRITE_DEFAULT_UI_FAILURE';
export const APP_SETTING_OVERWRITE_DEFAULT_UI_DISMISS_ERROR =
  'APP_SETTING_OVERWRITE_DEFAULT_UI_DISMISS_ERROR';
export const APP_SETTING_UPDATE_ENC_AWS_SETTING_BEGIN = 'APP_SETTING_UPDATE_ENC_AWS_SETTING_BEGIN';
export const APP_SETTING_UPDATE_ENC_AWS_SETTING_SUCCESS =
  'APP_SETTING_UPDATE_ENC_AWS_SETTING_SUCCESS';
export const APP_SETTING_UPDATE_ENC_AWS_SETTING_FAILURE =
  'APP_SETTING_UPDATE_ENC_AWS_SETTING_FAILURE';
export const APP_SETTING_UPDATE_ENC_AWS_SETTING_DISMISS_ERROR =
  'APP_SETTING_UPDATE_ENC_AWS_SETTING_DISMISS_ERROR';
export const APP_SETTING_RESET_ENCRYPTION_SETTING_BEGIN =
  'APP_SETTING_RESET_ENCRYPTION_SETTING_BEGIN';
export const APP_SETTING_RESET_ENCRYPTION_SETTING_SUCCESS =
  'APP_SETTING_RESET_ENCRYPTION_SETTING_SUCCESS';
export const APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE =
  'APP_SETTING_RESET_ENCRYPTION_SETTING_FAILURE';
export const APP_SETTING_RESET_ENCRYPTION_SETTING_DISMISS_ERROR =
  'APP_SETTING_RESET_ENCRYPTION_SETTING_DISMISS_ERROR';
export const APP_SETTING_CYPHER_TEXT_BEGIN = 'APP_SETTING_CYPHER_TEXT_BEGIN';
export const APP_SETTING_CYPHER_TEXT_SUCCESS = 'APP_SETTING_CYPHER_TEXT_SUCCESS';
export const APP_SETTING_CYPHER_TEXT_FAILURE = 'APP_SETTING_CYPHER_TEXT_FAILURE';
export const APP_SETTING_CYPHER_TEXT_DISMISS_ERROR = 'APP_SETTING_CYPHER_TEXT_DISMISS_ERROR';
export const APP_SETTING_GET_PROFILER_DATA_BEGIN = 'APP_SETTING_GET_PROFILER_DATA_BEGIN';
export const APP_SETTING_GET_PROFILER_DATA_SUCCESS = 'APP_SETTING_GET_PROFILER_DATA_SUCCESS';
export const APP_SETTING_GET_PROFILER_DATA_FAILURE = 'APP_SETTING_GET_PROFILER_DATA_FAILURE';
export const APP_SETTING_GET_PROFILER_DATA_DISMISS_ERROR =
  'APP_SETTING_GET_PROFILER_DATA_DISMISS_ERROR';
export const APP_SETTING_DELETE_PROFILER_BEGIN = 'APP_SETTING_DELETE_PROFILER_BEGIN';
export const APP_SETTING_DELETE_PROFILER_SUCCESS = 'APP_SETTING_DELETE_PROFILER_SUCCESS';
export const APP_SETTING_DELETE_PROFILER_FAILURE = 'APP_SETTING_DELETE_PROFILER_FAILURE';
export const APP_SETTING_DELETE_PROFILER_DISMISS_ERROR =
  'APP_SETTING_DELETE_PROFILER_DISMISS_ERROR';
export const APP_SETTING_UPDATE_AI_MODEL_CONFIG_BEGIN = 'APP_SETTING_UPDATE_AI_MODEL_CONFIG_BEGIN';
export const APP_SETTING_UPDATE_AI_MODEL_CONFIG_SUCCESS =
  'APP_SETTING_UPDATE_AI_MODEL_CONFIG_SUCCESS';
export const APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE =
  'APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE';
export const APP_SETTING_UPDATE_AI_MODEL_CONFIG_DISMISS_ERROR =
  'APP_SETTING_UPDATE_AI_MODEL_CONFIG_DISMISS_ERROR';
export const APP_SETTING_LOADER_SCREEN_SETTINGS_BEGIN = 'APP_SETTING_LOADER_SCREEN_SETTINGS_BEGIN';
export const APP_SETTING_LOADER_SCREEN_SETTINGS_SUCCESS =
  'APP_SETTING_LOADER_SCREEN_SETTINGS_SUCCESS';
export const APP_SETTING_LOADER_SCREEN_SETTINGS_FAILURE =
  'APP_SETTING_LOADER_SCREEN_SETTINGS_FAILURE';
export const APP_SETTING_LOADER_SCREEN_SETTINGS_DISMISS_ERROR =
  'APP_SETTING_LOADER_SCREEN_SETTINGS_DISMISS_ERROR';
export const APP_SETTING_REFRESH_PROJECT_BEGIN = 'APP_SETTING_REFRESH_PROJECT_BEGIN';
export const APP_SETTING_REFRESH_PROJECT_SUCCESS = 'APP_SETTING_REFRESH_PROJECT_SUCCESS';
export const APP_SETTING_REFRESH_PROJECT_FAILURE = 'APP_SETTING_REFRESH_PROJECT_FAILURE';
export const APP_SETTING_REFRESH_PROJECT_DISMISS_ERROR =
  'APP_SETTING_REFRESH_PROJECT_DISMISS_ERROR';
export const APP_SETTING_IMPORT_PROJECT_BEGIN = 'APP_SETTING_IMPORT_PROJECT_BEGIN';
export const APP_SETTING_IMPORT_PROJECT_SUCCESS = 'APP_SETTING_IMPORT_PROJECT_SUCCESS';
export const APP_SETTING_IMPORT_PROJECT_FAILURE = 'APP_SETTING_IMPORT_PROJECT_FAILURE';
export const APP_SETTING_IMPORT_PROJECT_DISMISS_ERROR = 'APP_SETTING_IMPORT_PROJECT_DISMISS_ERROR';
export const APP_SETTING_FETCH_FIGMATOKEN_BEGIN = 'APP_SETTING_FETCH_FIGMATOKEN_BEGIN';
export const APP_SETTING_FETCH_FIGMATOKEN_SUCCESS = 'APP_SETTING_FETCH_FIGMATOKEN_SUCCESS';
export const APP_SETTING_FETCH_FIGMATOKEN_FAILURE = 'APP_SETTING_FETCH_FIGMATOKEN_FAILURE';
export const APP_SETTING_FETCH_FIGMATOKEN_DISMISS_ERROR = 'APP_SETTING_FETCH_FIGMATOKEN_DISMISS_ERROR';
export const APP_SETTING_FETCH_FIGMA_DATA_BEGIN = 'APP_SETTING_FETCH_FIGMA_DATA_BEGIN';
export const APP_SETTING_FETCH_FIGMA_DATA_SUCCESS = 'APP_SETTING_FETCH_FIGMA_DATA_SUCCESS';
export const APP_SETTING_FETCH_FIGMA_DATA_FAILURE = 'APP_SETTING_FETCH_FIGMA_DATA_FAILURE';
export const APP_SETTING_FETCH_FIGMA_DATA_DISMISS_ERROR = 'APP_SETTING_FETCH_FIGMA_DATA_DISMISS_ERROR';
export const APP_SETTING_FETCH_FIGMA_IMAGE_BEGIN = 'APP_SETTING_FETCH_FIGMA_IMAGE_BEGIN';
export const APP_SETTING_FETCH_FIGMA_IMAGE_SUCCESS = 'APP_SETTING_FETCH_FIGMA_IMAGE_SUCCESS';
export const APP_SETTING_FETCH_FIGMA_IMAGE_FAILURE = 'APP_SETTING_FETCH_FIGMA_IMAGE_FAILURE';
export const APP_SETTING_FETCH_FIGMA_IMAGE_DISMISS_ERROR = 'APP_SETTING_FETCH_FIGMA_IMAGE_DISMISS_ERROR';
export const APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_BEGIN = 'APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_BEGIN';
export const APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_SUCCESS = 'APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_SUCCESS';
export const APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_FAILURE = 'APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_FAILURE';
export const APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_DISMISS_ERROR = 'APP_SETTING_DELETE_FIGMA_TO_HTML_DATA_DISMISS_ERROR';
export const APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_BEGIN = 'APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_BEGIN';
export const APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_SUCCESS = 'APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_SUCCESS';
export const APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_FAILURE = 'APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_FAILURE';
export const APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_DISMISS_ERROR = 'APP_SETTING_DELETE_FIGMA_TOKEN_DETAILS_DISMISS_ERROR';
export const APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_BEGIN = 'APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_BEGIN';
export const APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_SUCCESS = 'APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_SUCCESS';
export const APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_FAILURE = 'APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_FAILURE';
export const APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_DISMISS_ERROR = 'APP_SETTING_FETCH_FIGMA_TO_HTML_DATA_DISMISS_ERROR';
export const APP_SETTING_GENERATE_FIGMA_TO_HTML_BEGIN = 'APP_SETTING_GENERATE_FIGMA_TO_HTML_BEGIN';
export const APP_SETTING_GENERATE_FIGMA_TO_HTML_SUCCESS = 'APP_SETTING_GENERATE_FIGMA_TO_HTML_SUCCESS';
export const APP_SETTING_GENERATE_FIGMA_TO_HTML_FAILURE = 'APP_SETTING_GENERATE_FIGMA_TO_HTML_FAILURE';
export const APP_SETTING_GENERATE_FIGMA_TO_HTML_DISMISS_ERROR = 'APP_SETTING_GENERATE_FIGMA_TO_HTML_DISMISS_ERROR';
